import React from 'react';
import styles from '../../../styles/portfolio/under_construction.scss';


export const UnderConstruction = props => {
    return (
        <span className={styles.container}>
            <span>
                We are sorry but this section is not ready yet. If you are interested in it please send an email
                to <span onClick={onClick} className={styles.mailto}>bekos.christopher@gmail.com</span>.
            </span>
            <img className={styles.img} src={require('../../../resources/images/under_construction.png')} />
        </span>
    )

    function onClick() {
        window.location.href = 'mailto:bekos.christopher@gmail.com';
    }
};
